export const FAQ_ITEMS = [
  {
    question: "Cât durează până primesc melodia?",
    answer: "Timpul depinde de pachet și de opțiunile alese. În mod normal, livrarea standard este de câteva zile lucrătoare, iar livrarea rapidă poate fi disponibilă ca extra sau inclusă în anumite pachete.",
  },
  {
    question: "Ce primește clientul la final?",
    answer: "Primești melodia finală în format digital audio, creată pe baza poveștii tale. În funcție de pachet, pot fi incluse versuri, voce, finisare audio și revizii.",
  },
  {
    question: "Cum se livrează melodia?",
    answer: "Melodia este livrată digital printr-un link TuneForUs, iar în unele cazuri poate fi sincronizată și prin pCloud pentru backup sau acces alternativ.",
  },
  {
    question: "Pot cere modificări după livrare?",
    answer: "Da. Dacă pachetul include revizii, poți cere o revizie direct din cont. Dacă nu mai ai revizii incluse, poți solicita modificări contra-cost.",
  },
  {
    question: "Ce drepturi am asupra melodiei?",
    answer: "Melodia este creată pentru folosire personală, cadou și distribuire necomercială. Pentru utilizări comerciale sau campanii publice, este recomandat să ne contactezi înainte.",
  },
  {
    question: "Trebuie să am o poveste foarte lungă?",
    answer: "Nu. Ajută să ne dai detalii sincere despre persoană, ocazie și emoția dorită, dar formularul te ghidează pas cu pas.",
  },
];

export const buildFaqJsonLd = (items = FAQ_ITEMS) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (items || []).map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});

export const faqJsonLd = buildFaqJsonLd(FAQ_ITEMS);
